import React, { Component } from 'react';
import PropTypes from 'prop-types';
import JwPagination from 'jw-react-pagination';
import { Link } from 'react-router-dom';
import Info from './Info';
import { formatNumber } from '../../../../utils/helpers';
import LazyBg from '../../../UI/LazyImage/LazyBg';
import './List.css';

class SpacesDesktop extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            pageOfItems: [],
        };
    }

    onChangePage = (pageOfItems) => {
        this.setState({ pageOfItems });
    }
    
    render() {
        const { property, filters } = this.props;
        const availableSqFtMin = filters.availableSqFt && filters.availableSqFt.value.min;
        const availableSqFtMax = filters.availableSqFt && filters.availableSqFt.value.max;
        const imgUrl = property.thumbnail
            ? `${process.env.RAZZLE_ASSET_URL}${property.thumbnail}`
            : '/thumbnail';
        const customLabels = {
            previous: '\u276E',
            next: '\u276F',
        };

        return (
            <div className="columns vertical-align is-multiline">
                <div className="column is-full is-hidden-widescreen">
                    <div className="property-title">{property.name}</div>
                    <div className="property-subtitle">{`${property.city}, ${(property.state==='BRITISH COLUMBIA') ? 'BC' : property.state.substring(0, 2)}`}</div>
                </div>

                <div className="column is-2-desktop is-one-fifth-widescreen is-2-fullhd">
                    <Link to={`/office/${property.slug}`}>
                        <LazyBg src={imgUrl} className="lazy-image property-image image is-1by1" />
                    </Link>
                </div>

                <div className="column is-offset-1-desktop is-4-desktop is-hidden-widescreen">
                    <Info property={property} filters={filters} />
                </div>

                <div className={`column is-full is-four-fifths-widescreen is-10-fullhd ${property.spaces[0] ? '' : 'column-empty'}`}>
                    <Link to={`/office/${property.slug}`} className="is-hidden-desktop-only">
                        <div className="property-title">{property.name}</div>
                    </Link>
                    <div className="columns">
                        <div className="column is-one-quarter-widescreen is-hidden-desktop-only">
                            <div className="property-subtitle">{`${property.city}, ${(property.state==='BRITISH COLUMBIA') ? 'BC' : property.state.substring(0, 2)}`}</div>
                            <Info property={property} filters={filters} />
                        </div>
                            {/* <div className="column">
                                <div className="space-wrapper">
                                    <div className="columns">
                                        <div className="space-titles-wrapper">
                                            <div className="column is-one-fifth-desktop">
                                                <div className="space-info-title">Address</div>
                                            </div>
                                            <div className="column">
                                                <div className="space-info-title">Floor</div>
                                            </div>
                                            <div className="column">
                                                <div className="space-info-title">Suite</div>
                                            </div>
                                            <div className="column">
                                                <div className="space-info-title">SQ. FT.</div>
                                            </div>
                                            <div className="column">
                                                <div className="space-info-title">Max Contig.</div>
                                            </div>
                                            <div className="column">
                                                <div className="space-info-title">Min. Divisible</div>
                                            </div>
                                            <div className="column">
                                                <div className="space-info-title">Floorplan</div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.pageOfItems.map(item =>
                                        <div className="columns" key={item.id}>
                                            <div className="space-info-wrapper">
                                                <div className="column is-one-fifth-desktop">
                                                    <div className="space-info">{item.street_address}</div>
                                                </div>
                                                <div className="column">
                                                    <div className="space-info">{item.floor}</div>
                                                </div>
                                                <div className="column">
                                                    <div className="space-info">{item.suite}</div>
                                                </div>
                                                <div className="column">
                                                    <div className={`space-info 
                                                        ${item.space_available >= availableSqFtMin && item.space_available <= availableSqFtMax && filters.availableSqFt ? 'active' : ''}
                                                        ${item.space_available >= 100000 && availableSqFtMax >= 100000 ? 'active' : ''}`}>
                                                        {formatNumber(item.space_available)}
                                                    </div>
                                                </div>
                                                <div className="column">
                                                    <div className={`space-info 
                                                        ${item.maximum_contiguous >= availableSqFtMin && item.maximum_contiguous <= availableSqFtMax && filters.availableSqFt ? 'active' : ''}
                                                        ${item.maximum_contiguous >= 100000 && availableSqFtMax >= 100000 ? 'active' : ''}`}>
                                                        {formatNumber(item.maximum_contiguous)}
                                                    </div>
                                                </div>
                                                <div className="column">
                                                    <div className={`space-info 
                                                        ${item.minimum_divisible >= availableSqFtMin && item.minimum_divisible <= availableSqFtMax && filters.availableSqFt ? 'active' : ''}
                                                        ${item.minimum_divisible >= 100000 && availableSqFtMax >= 100000 ? 'active' : ''}`}>
                                                        {formatNumber(item.minimum_divisible)}
                                                    </div>
                                                </div>
                                                <div className="column">
                                                    {item.floor_plans[0] ?
                                                        <a href={`${item.floor_plans}`}  target="_blank" rel="noopener noreferrer" className="space-info-floorplan">Download</a>
                                                        : <div className="space-info-floorplan inactive">Unavailable</div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <JwPagination pageSize={4} items={this.props.spacesInfo} onChangePage={this.onChangePage} labels={(this.props.spacesInfo.length > 40) && customLabels} />
                            </div> */}
                    </div>
                </div>
            </div>
        );
    }
}

SpacesDesktop.propTypes = {
    property: PropTypes.shape({
        name: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        spaces: PropTypes.arrayOf(PropTypes.object).isRequired, // TODO: expand
        street_address: PropTypes.string.isRequired,
        thumbnail: PropTypes.string,
    }).isRequired,
    filters: PropTypes.object,
    spacesInfo: PropTypes.array,
};

export default SpacesDesktop;
